import { add as addFn } from 'date-fns/add';
import { format as dateFormat } from 'date-fns/format';
import { isDate as isDateFn } from 'date-fns/isDate';
import { isValid as isValidFn } from 'date-fns/isValid';
import { parse as parseDateFormat } from 'date-fns/parse';
import { parseISO as parseISODate } from 'date-fns/parseISO';
import { formatDistanceStrict } from 'date-fns';
import { es, enGB, enUS, de, fr, it, pt, ru, ptBR, da } from 'date-fns/locale';

const LOCALE_DATES = {
    'es-ES': es,
    es: es,
    'en-GB': enGB,
    en: enGB,
    'en-US': enUS,
    'de-DE': de,
    'fr-FR': fr,
    'it-IT': it,
    'pt-PT': pt,
    'ru-RU': ru,
    'pt-BR': ptBR,
    'da-DK': da,
};

export const DATE_PLACEHOLDERS = {
    'es-ES': 'dd/mm/yyyy',
    es: 'dd/mm/yyyy',
    'en-GB': 'dd/mm/yyyy',
    en: 'dd/mm/yyyy',
    'en-US': 'mm/dd/yyyy',
    'de-DE': 'dd.mm.yyyy',
    'fr-FR': 'dd/mm/yyyy',
    'it-IT': 'dd/mm/yyyy',
    'pt-PT': 'dd/mm/yyyy',
    'ru-RU': 'dd.mm.yyyy',
    'pt-BR': 'dd/mm/yyyy',
    'da-DK': 'dd/mm/yyyy',
};

export const isDate = isDateFn;
export const isValid = isValidFn;
export const add = addFn;
export function formatDate(date, locale = 'en-US', format = 'P p') {
    let d = date;
    if (!isDateFn(d)) d = new Date(date);
    return dateFormat(d, format, {
        locale: LOCALE_DATES[locale],
    });
}

export function parseISO(date) {
    let d = date;
    if (isDateFn(d)) return d;
    return parseISODate(d);
}

function parseDate(date, locale = 'en-US', format = 'P p') {
    let d = date;
    if (!isDateFn(d)) d = new Date(date);
    return parseDateFormat(d, format, {
        locale: LOCALE_DATES[locale],
    });
}

export function parseDateWithFormat(date, locale = 'en-US', format = 'P p') {
    let d = date;
    if (!date) return date;
    try {
        return parseDateFormat(d, format, 0, {
            locale: LOCALE_DATES[locale],
        });
    } catch {
        return date;
    }
}

export function isValidDateWithFormat(date, locale = 'en-US', format = 'P p') {
    let d = date;
    try {
        return isValid(parseDateFormat(d, format, 0, { locale: LOCALE_DATES[locale] }));
    } catch {
        return false;
    }
}

export function formatDateWithFormat(date, locale = 'en-US', formatIn = 'P p', formatOut = 'P p') {
    let d = date;
    const jsDate = parseDateFormat(d, formatIn, 0, { locale: LOCALE_DATES[locale] });
    if (!isValid(jsDate)) return date;
    return formatDate(jsDate, locale, formatOut);
}

export const getTimeUntilNow = (date, locale = 'en-US') => {
    return formatDistanceStrict(new Date(date), new Date(), { locale: LOCALE_DATES[locale] });
};
